module.exports = __webpack_public_path__ + "static/media/home_banner_welcome_en.849fe365.svg";